import classnames from 'classnames';
import {
  useDeliveryInfo,
  useDeliveryPickup,
  usePickupInfo
} from '~/context/vdp/DeliveryPickupContext';
import { Split, Wrapper } from './Availability.styles';
import DeliveryBox from './Delivery';
import PickupBox from './Pickup';
import { PickupAndDeliveryState } from '../PickupAndDelivery';
import Shipping from '../Shipping';

type OwnProps = {
  componentState: PickupAndDeliveryState;
};

export default function PickupAndDelivery({ componentState }: OwnProps) {
  const pickupInfo = usePickupInfo();
  const deliveryInfo = useDeliveryInfo();
  const { isLoaded } = useDeliveryPickup();
  const hideDelivery =
    isLoaded && (!deliveryInfo || deliveryInfo.isRestrictedLocation);
  const hidePickup = isLoaded && !pickupInfo;
  const hideBorder = hideDelivery || hidePickup;

  const wrapperClassNames = classnames(
    { 'one-box': hideBorder },
    {
      'one-row': !hideBorder
    },
    {
      'max-w-[368px]': componentState === PickupAndDeliveryState.DesktopWithCars
    }
  );

  return (
    <div className="center flex flex-col justify-center">
      <Wrapper className={wrapperClassNames} data-qa="soonest-availability">
        {!hidePickup && (
          <PickupBox pickup={pickupInfo} componentState={componentState} />
        )}
        {!hideBorder && (
          <Split>
            <div className="absolute h-full border-r border-grey-2" />
            <span className="z-1 bg-white py-8 text-blue-6 tl-label-xs m:py-16 m:tl-label-s">
              OR
            </span>
          </Split>
        )}
        {!hideDelivery && (
          <DeliveryBox
            delivery={deliveryInfo}
            componentState={componentState}
          />
        )}
      </Wrapper>
      {componentState === PickupAndDeliveryState.DesktopWithCars && (
        <Shipping />
      )}
    </div>
  );
}
